import { findAnimationByActionId } from 'Pods/ThreeDStudio/Services/Constants/animations'
import { getAssetByTypeAndSource } from 'Pods/ThreeDStudio/Shared/Utils/getAssetByTypeAndSource'
import {
  ACTION,
  DEFAULT_ANIMATE_SETTINGS,
  PROVIDER,
  VIEWER_SIDEBAR_TAB,
} from 'Pods/ThreeDStudio/Store/constants'

import { getModelFormatOutput } from './getModelFormatOutput'

/**
 * Builds the ThreeDStudio store patch for a Meshy animation-pro run. Maps the
 * run's numeric Meshy library id back to the local library slug the Animate
 * tab selects on, and opens the viewer sidebar on the ANIMATE tab. An id
 * outside the shipped library leaves the grid with nothing selected.
 *
 * @param {Object} openedModel - Run object from the library
 * @returns {Object} parsedData - ThreeDStudio store patch
 */
export const parseMeshyAnimationProData = (openedModel) => {
  const {
    id: sessionId,
    modelFormatOutput: rawModelFormatOutput,
    generatorSessionId,
    outputAssets,
  } = openedModel
  // Persisted Meshy rows store the library id as `action_code`; the optimistic
  // builder path sends the same key, camelCase only guards a serializer change.
  const providerRunAttributes = openedModel.providerRunAttributes || {}
  const actionCode = providerRunAttributes.action_code ?? providerRunAttributes.actionCode
  const { id: animationId } = findAnimationByActionId(actionCode) || {}
  const {
    assetId: inputThreeD,
    fileUrl: inputThreeDUrl,
  } = getAssetByTypeAndSource(outputAssets, '3d_model', 'ai_generated')
  const modelFormatOutput = getModelFormatOutput({
    modelFormatOutput: rawModelFormatOutput,
    modelUrl: inputThreeDUrl,
  })

  const schema = { enhancedAction: ACTION.ANIMATION, enhancedProvider: PROVIDER.MESHY }
  const generation = { sessionId, generatorSessionId }
  const viewer = { fileFormat: modelFormatOutput, inputThreeD }
  const animateSettings = {
    animationId: animationId ?? DEFAULT_ANIMATE_SETTINGS.animationId,
  }
  const ui = {
    isModelSettingsOpen: false,
    isViewerSidebarOpen: true,
    activeViewerSidebarTab: VIEWER_SIDEBAR_TAB.ANIMATE,
  }

  return {
    openedModel,
    schema,
    animateSettings,
    ui,
    generation,
    viewer,
  }
}
